export default "<h3>\n  Καλώς ήλθατε στο Σύστημα Διαχείρισης Ψυγείων της ΚΡΙ-ΚΡΙ.\n</h3>\n"